<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    @if (currentContent === 'team') {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Team
        </h4>
        <div class="card-body">
          <h5 class="filters">Filters</h5>
          <form class="bg-light border rounded-lg px-3 pt-2 pb-1 filters" (ngSubmit)="search()">
            <div class="row">
              <div class="form-group col-md-4">
                <label>Last name</label>
                <input type="text" class="form-control" [ngClass]="{ 'is-touched': lastName }"
                  name="lastName" [(ngModel)]="lastName" (change)="search()" placeholder="eg: Zurlo">
              </div>
              <div class="form-group col-md-4">
                <label>Department</label>
                <select class="form-control" [ngClass]="{ 'is-touched': department }"
                  name="department" [(ngModel)]="department" (change)="search()">
                  <option value="" selected>Any department</option>
                  @for (department of departments; track department) {
                    <option [value]="department">{{department}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Position</label>
                <select class="form-control" [ngClass]="{ 'is-touched': job }"
                  name="job" [(ngModel)]="job" (change)="search()">
                  <option value="" selected>Any position</option>
                  @for (job of jobs; track job) {
                    <option [value]="job">{{job}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label>Site</label>
                <select class="form-control" [ngClass]="{ 'is-touched': site }"
                  name="site" [(ngModel)]="site" (change)="search()">
                  <option value="" selected>Any site</option>
                  @for (site of sites; track site) {
                    <option [value]="site">{{site}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Client</label>
                <select class="form-control" [ngClass]="{ 'is-touched': client }"
                  name="client" [(ngModel)]="client" (change)="search()">
                  <option value="" selected>Any client</option>
                  @for (client of clients; track client) {
                    <option [value]="client._id">{{client.name}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Disabled</label>
                <select class="form-control" [ngClass]="{ 'is-touched': disabled }"
                  name="disabled" [(ngModel)]="disabled" (change)="search()">
                  <option value="">Any</option>
                  <option value="0" selected>No</option>
                  <option value="1">Yes</option>
                </select>
              </div>
            </div>
          </form>
          <hr>
            <div class="row">
              <div class="col-md-6">
                @if (isLoading.team) {
                  <p>
                    <app-spinner [condition]="isLoading.team"></app-spinner>
                  </p>
                }
                @if (!isLoading.team && team?.length === 0) {
                  <p>
                    Nothing found.
                  </p>
                }
                @if (isSearching && !isLoading.team && team?.length) {
                  <p>
                    <span class="badge badge-primary">{{count}}</span> results found:
                  </p>
                }
              </div>
              <div class="col-md-6 text-end">
                @if (canExportCsv) {
                  <button class="btn btn-primary btn-sm hide-print" (click)="search(0, true)"
                    data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Export takes account of the current filters">
                    <i class="fa fa-download"></i> Export (CSV)
                  </button>
                }
              </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-2">
              @for (user of team; track user) {
                <div class="col mb-3">
                  <app-user [user]="user"></app-user>
                </div>
              }
            </div>
            @if (team?.length) {
              <div>
                <app-pagination [isLoading]="isLoading.team" [count]="count" [perPage]="perPage" [page]="page" eventName="getUsers"></app-pagination>
                <app-spinner [condition]="isLoading.team"></app-spinner>
              </div>
            }
          </div>
        </div>
      }
    </div>

  </div>

